"use strict";
exports.__esModule = true;
var floor = function (value, digits) {
    return digits ? Math.floor(value * Math.pow(10, digits)) / Math.pow(10, digits) : Math.floor(value);
};
exports["default"] = floor;
